(function () {
  var menu = document.querySelector('.menu-toggle');
  var nav = document.querySelector('#site-nav');
  if (menu && nav) {
    menu.addEventListener('click', function () {
      var isOpen = menu.getAttribute('aria-expanded') === 'true';
      menu.setAttribute('aria-expanded', String(!isOpen));
      nav.classList.toggle('open', !isOpen);
    });
  }

  var productForm = document.querySelector('.product-form');
  var variantSelect = productForm && productForm.querySelector('.variant-select');
  var price = document.querySelector('[data-product-price]');
  var addButton = document.querySelector('[data-add-button]');
  if (!variantSelect || !price || !addButton) return;

  variantSelect.addEventListener('change', function () {
    var option = variantSelect.options[variantSelect.selectedIndex];
    var available = option.dataset.available === 'true';
    price.textContent = option.dataset.price || price.textContent;
    addButton.disabled = !available;
    addButton.firstChild.textContent = available ? 'Add to cart ' : 'Sold out ';
  });
})();
